// extracted by mini-css-extract-plugin
export default {"profilePic":"Picture_profilePic__n5U3Z","avatar":"Picture_avatar__9t6BN"};